import styled from 'styled-components';
import { colors } from 'Constants/Colors';

export const CardContainer = styled.a`
  display: flex;
  flex-direction: column;
  width: 11vw;
  height: 24vh;
  background: ${colors.WHITE};
  border-radius: 1rem;
  justify-content: center;
  cursor: pointer;
  text-decoration: none;
  position: relative;
`;

export const IconContaniner = styled.div`
  display: flex;
  width: 100%;
  height: 70%;
  justify-content: center;
  align-items: center;
  position: relative;
  border-bottom: 0.1rem solid ${colors.GRAY_TEXT_FIELD};
`;

export const IconCloseContaniner = styled.div`
  position: absolute;
  background: ${colors.RED};
  display: flex;
  align-items: center;
  border-radius: 50%;
  z-index: 100;
  right: -0.4rem;
  top: -0.5rem;
  cursor: pointer;
`;

export const InfoContainer = styled.div`
  display: flex;
  width: 100%;
  height: 30%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
`;

export const Title = {
  fontFamily: 'var(--app-font)',
  fontWeight: 'bold',
  fontSize: '1vmax',
  color: colors.BLACK,
};

export const Size = {
  fontFamily: 'var(--app-font)',
  fontSize: '1vmax',
  color: colors.GRAY_DARK,
};

export const Image = {
  width: '40%',
  height: '50%',
};

export default {
  CardContainer,
  IconContaniner,
  IconCloseContaniner,
  InfoContainer,
  Title,
  Size,
  Image,
};
